const LOCAL_STORAGE = {
  ACCESS_TOKEN: 'KIOSK_CMS_AccessToken',
  REFRESH_TOKEN: 'KIOSK_CMS_RefreshToken',
  ABILITIES: 'KIOSK_CMS_Abilities',
  LANGUAGE: 'KIOSK_CMS_Language',
  PREVIEW_DATA: 'KIOSK_CMS_PreviewData'
};

export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const COLORS = {
  COOL_BLACK: '#002b60'
};

export const DEFAULT_QUERY_OPTION = {
  retry: 0,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

export const URL_CONST = {
  MEDIA_FILE_UPLOAD_CHUNK: 'api/v1/media-files/upload-chunk',
  MEDIA_FILE_MERGE_CHUNK: 'api/v1/media-files/merge-chunk'
};

export const TARGET_LIST_OPTIONS = [
  {
    label: 'Mở liên kết trong tab hiện tại',
    value: 1
  },
  {
    label: 'Mở liên kết trong tab mới',
    value: 2
  },
];
export const TARGET_LIST_LABEL = [
  {
    label: '_self',
    value: 1
  },
  {
    label: '_blank',
    value: 2
  },
];

export const socialList: OptionType[] = [
  {
    label: 'Facebook',
    value: 1,
  },
  {
    label: 'Twitter',
    value: 2,
  },
];

export const newsListSortBy: OptionType[] = [
  {
    label: 'Thứ tự hiển thị',
    value: 'displayOrder',
  },
  {
    label: 'Ngày đăng',
    value: 'displayOrder',
  },
];

export const newsListSortType: OptionType[] = [
  {
    label: 'Ascending',
    value: 'asc',
  },
  {
    label: 'Descending',
    value: 'desc',
  },
];

export default LOCAL_STORAGE;

export const INTEGER_REGEX = /^[+-]?((\d*\.?\d+(?:[Ee][+-]?\d+)?)|(\d+\.))$/;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const PHONE_REGEX = /^0[1-9][0-9]{8}$/;

export const ROUTE_PATHS = {
  /* BLOCK TEMPLATE */
  PAGE_TEMPLATE_MANAGEMENT: '/page-templates',
  /* PAGE */
  PAGE_MANAGEMENT: '/page-management',
  PAGE_DETAIL: '/page',
  /* FILE */
  FILE_MANAGEMENT: '/files-management',
  /* MENU */
  MENU_MANAGEMENT: '/menu-management',
  MENU_DETAIL: '/menu',
  /* NEWS */
  NEWS_MANAGEMENT: '/news-management',
  NEWS_DETAIL: '/news',
  NEWS_CATEGORY_MANAGEMENT: '/news-category-management',
  NEWS_CATEGORY_DETAIL: '/news-category',
  /* BANNER */
  BANNER_MANAGEMENT: '/banner-management',
  BANNER_DETAIL: '/banner',
  /* TRANSLATIONS */
  FE_TRANSLATION_MANAGEMENT: '/fe-translation',
  CMS_TRANSLATION_MANAGEMENT: '/cms-translation',
  /* REDIRECT */
  REDIRECT_MANAGEMENT: '/redirect',
  REDIRECT_IMPORT: '/redirect-import',
  /* ACTIVITY */
  ACTIVITY_MANAGEMENT: '/activity-logs',
  /* ROLES */
  ROLES_MANAGEMENT: '/roles',
  ROLES_DETAIL: '/role-detail',
  /* USERS */
  USERS_MANAGEMENT: '/users-management',
  USERS_DETAIL: '/user',
  /* FAQ */
  FAQ_MANAGEMENT: '/faq-management',
  FAQ_DETAIL: '/faq',
  FAQ_CATEGORY_MANAGEMENT: '/faq-category-management',
  FAQ_CATEGORY_DETAIL: '/faq-category',
  /* CONFIG */
  SYSTEM_MANAGEMENT: '/system',
  SYSTEM_CONFIG_MANAGEMENT: '/config-management',
  ERRORS_MANAGEMENT: '/errors-management',
  /* AUTH */
  LOGIN: '/login',
  /* CONTACT */
  CONTACT_MANAGEMENT: '/contact-management',
  CONTACT_PROBLEM_MANAGEMENT: '/contact-problem-management',
  CONTACT_PROBLEM_DETAIL: '/contact-problem-detail',
  /* EMAIL TEMPLATE */
  EMAIL_TEMPLATE_MANAGEMENT: '/email-template-management',
  EMAIL_TEMPLATE_DETAIL: '/email-template-detail',
  /* FORM */
  FORM_MANAGEMENT: '/form-management',
  FORM_DETAIL: '/form-detail',
  /* STATIC BLOCK */
  STATIC_BLOCK_MANAGEMENT: '/static-block-management',
  STATIC_BLOCK_DETAIL: '/static-block-detail',
  /* KIOSK */
  KIOSK_MANAGEMENT: '/kiosk-management',
  KIOSK_DETAIL: '/kiosk-detail',
  GENERATE_QRCODE: '/generate-qrcode',
  KIOSK_GROUP_MANAGEMENT: '/kiosk-group-management',
  KIOSK_GROUP_DETAIL: '/kiosk-group-detail',
  /* SURVEY */
  SURVEY_QUESTION_MANAGEMENT: '/survey-question-management',
  SURVEY_QUESTION_DETAIL: '/survey-question-detail',

  /* DASHBOARD */
  OLD_DASHBOARD: '/old-dashboard',
  DASHBOARD_2024: '/dashboard-2024',
  DASHBOARD_2025: '/dashboard-2025',
  DASHBOARD: '/dashboard',

  /* REPORTS */
  REPORTS_MANAGEMENT: '/reports-management',

  /* SURVEY_RESULT */
  SURVEY_RESULT_MANAGEMENT: '/survey-result-management',
  SURVEY_RESULT_DETAIL: '/survey-result-detail',

  /* Tracking */
  TRACKING_MANAGEMENT: '/tracking-management',

  /* Kiosk Warranty */
  KIOSK_WARARNTY_MANAGEMENT: '/kiosk-warranty-management',
  KIOSK_WARARNTY_DETAIL: '/kiosk-warranty-detail',

  /* EXTERNAL MANAGER */
  EXTERNAL_MANAGER: '/external-manager',
  EXTERNAL_MANAGER_DETAIL: '/external-manager-detail',

  DASHBOARD_MANAGEMENT: '/dashboard-management',

  EPIDEMIOLOGY_MANAGEMENT: '/epidemiology-management',

  RISK_OVERVIEW_MANAGEMENT: '/risk-overview-management',

  RISK_HEART_MANAGEMENT: '/risk-heart-management',

  RISK_RENAL_MANAGEMENT: '/risk-renal-management',

  CLINIC_MANAGER: '/clinic-manager',
  CLINIC_DETAIL: '/clinic-detail',

  /* SURVEY_RESULT */
  HEALTH_SERVICE_RESULT_MANAGEMENT: '/heath-service-result-management',
  HEALTH_SERVICE_RESULT_DETAIL: '/heath-service-result-detail',

  CLINIC_RESULT_MANAGEMENT: '/clinic-result-management',
  CLINIC_RESULT_DETAIL: '/clinic-result-detail',

  LOGGING_MANAGEMENT: '/logging-management',
};

export const videoTypes: OptionType[] = [
  {
    label: 'Upload',
    value: 'upload'
  },
  {
    label: 'Youtube',
    value: 'youtube'
  },
  {
    label: 'Vimeo',
    value: 'vimeo'
  },
];

export const defaultSessionsCode = {
  hanoiCode: '1028580',
  sontayCode: '9074107',
  saigonCode: '1028581',
  danangCode: '1028809',
};

export const printerOptions = [
  {
    value: '57mm',
    label: '57 mm'
  },
  {
    value: '80mm',
    label: '80 mm'
  },
  {
    value: '80mmc',
    label: '80 mm Cơ'
  },
];

export const typeKiosk = [
  {
    value: '1',
    label: 'QR'
  },
  {
    value: '2',
    label: 'Kiosk'
  },
  {
    value: '3',
    label: 'HIS'
  },
];

export const httpLogType = [
  {
    value: 'getAccessToken',
    label: 'httpLog.getAccessToken'
  },
  {
    value: 'validateSurvey',
    label: 'httpLog.validateSurvey'
  },
  {
    value: 'sendSurvey',
    label: 'httpLog.sendSurvey'
  },
];
